<div class="support-container container">
  <div class="row" id="iframeContainer">
    <div class="col-12" style="height: 100%;">
      <iframe class="clickup-embed" id='iframe' src="https://forms.clickup.com/2175885/f/22cwd-18142/KE2ZZTGKSWUT2HR0ZQ"
        onwheel="" width="100%" height="100%" style="background: transparent; border:  transparent"></iframe>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/support/support.component.html